module.exports = __webpack_public_path__ + "static/img/increment07.d610226.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/increment07.png
// module id = fzUh
// module chunks = 0